export const businessIdSaga = (state) => state.businessInfoReducer.businessId;
export const onboardingStatusSaga = (state) => state.businessInfoReducer.onboardingStatus;
export const onboardingBusinessInfoSaga = (state) => state.businessInfoReducer.businessInfoSuccess;
